
define('text!modules/ui/directives/progress-tracker/template.html',[],function () { return '<ol class=progressTracker><li ng:repeat="step in steps" ng:class=step.meta.status translate="{{ step.meta.label }}"></li></ol>';});

